export const PAGINATOR_BIG_PAGE_SIZE = 1000
export const DEFAULT_LOCALE = 'es'
